import React from 'react'
// import { NavLink as Nav.Link } from 'react-router-dom'
import _ from '../misc/i18n';
import logo from '../img/CAL-logo.png'
import { MasterCALDostepnyWrapper, SuperUserWrapper, CALLoginWrapper, CRMWrapper, KlinikaDrzwiAdminWrapper, GwarancjaAdminWrapper/* ReklamacjeAdminWrapper, CALLoginWrapper */ } from './Main'
import NotificationsContainer from './common/notifications/notifications'
import TodosContainer from './common/todos/TodosContainer'
import { Nav, NavDropdown } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

// The Header creates links that can be used to navigate
// between routes.
const Header = (props) => (
  <header>
    <div className='header-full-width'>
      <div className="container">
        <div className="row">
          <div className="col-lg-2 col-3">
            <div className='top-logo'>
              <a href="http://www.drzwi-cal.pl/"><img src={logo} className="logo img-responsive" alt="Logo" /></a>
            </div>
            <div className='claim d-none d-lg-block d-xl-block'>
              {_('PRAWDZIWE DRZWI')}
            </div>
          </div>
          <div className="col-md-6 d-none d-xl-block">
            {/* <div className="system-obslugi">{_('System obsługi sprzedaży')}</div><div className="CALkulator30">&nbsp;CALkulator 4.0</div>	</div>
            <div className="col-md-6 d-none d-lg-block d-xl-none"><div className="CALkulator30">&nbsp;CALkulator 3.0</div> */}
          </div>

          {props.session && props.session.loggedIn && <div className="col-1 mt-3"><TodosContainer /></div>}
          {props.session && props.session.loggedIn && <div className="col-1 mt-3"><NotificationsContainer /></div>}
          <div className="col-lg-2 col-3 d-sm-4">
            {
              props.showMenu && props.session && props.session.loggedIn && <div className="logout"><a title={_("wyloguj")} href="/wyloguj.php">
                <span className="d-none d-md-inline d-lg-inline d-xl-inline">{_("wyloguj")}</span>
                <i className="fa fa-power-off" aria-hidden="true"></i></a>
              </div>
            }
            <div id="flags-container" className='float-right'>
              <div className='float-right'>
                <div className="lang-flag"><a title="Język polski" href="index.php?lang=pl">PL</a></div>
                <div className="lang-flag"><a title="English language" href="index.php?lang=en">EN</a></div>
                <div className="lang-flag"><a title="Deutsche Sprache" href="index.php?lang=de">DE</a></div>
                <div className="lang-flag"><a title="Pусский язык" href="index.php?lang=ru">RU</a></div>
              </div>
              <div className='float-right'>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>    {props.showMenu && props.session && props.session.loggedIn && <div className="container">
      <Nav variant="tabs">
        <Nav.Item><Nav.Link href="https://calkulator.drzwi-cal.pl/logowanie.php">{_('Strona główna')}</Nav.Link></Nav.Item>

        <LinkContainer to="/login" exact={true}><Nav.Link>{_('Lista operatorów')}</Nav.Link></LinkContainer>
        <LinkContainer to="/login/nowy"><Nav.Link>{_('Dodaj nowego operatora')}</Nav.Link></LinkContainer>        <NavDropdown title={_("Konkursy")} id="nav-dropdown-konkursy">
          <MasterCALDostepnyWrapper session={props.session}>
            <LinkContainer to="/konkursy/masterCAL"><NavDropdown.Item>{_('MasterCAL')}</NavDropdown.Item></LinkContainer>
          </MasterCALDostepnyWrapper>
          <MasterCALDostepnyWrapper session={props.session}>
            <LinkContainer to="/konkursy/archiCAL"><NavDropdown.Item>{_('ArchiCAL')}</NavDropdown.Item></LinkContainer>
          </MasterCALDostepnyWrapper>
          {/* <LinkContainer to="/konkursy/4x4"><NavDropdown.Item>{_('4x4')}</NavDropdown.Item></LinkContainer> */}
        </NavDropdown>
        <LinkContainer to="/wyceny"><Nav.Link to='/wyceny'>{_('Zapytania o wycenę')}</Nav.Link></LinkContainer>
        <LinkContainer to="/reklamacje"><Nav.Link>{_('Reklamacje')}</Nav.Link></LinkContainer>
        <CRMWrapper>
          <NavDropdown title="CRM" id="nav-dropdown-crm">
            <CALLoginWrapper><LinkContainer to='/crm/dodaj'><NavDropdown.Item>Dodaj nowy kontakt</NavDropdown.Item></LinkContainer></CALLoginWrapper>
            <LinkContainer to='/crm/kontakty/90'><NavDropdown.Item>Lista kontaktów</NavDropdown.Item></LinkContainer>
            <CALLoginWrapper><LinkContainer to='/crm/importFromFile'><NavDropdown.Item>Importuj kontakty z pliku</NavDropdown.Item></LinkContainer></CALLoginWrapper>
          </NavDropdown>
        </CRMWrapper>
        <KlinikaDrzwiAdminWrapper>
          <LinkContainer to="/klinikaDrzwi/lista"><Nav.Link>Klinika drzwi</Nav.Link></LinkContainer>
        </KlinikaDrzwiAdminWrapper>
        <GwarancjaAdminWrapper>
          <LinkContainer to="/gwarancja/lista"><Nav.Link>Gwarancja</Nav.Link></LinkContainer>
        </GwarancjaAdminWrapper>
        <SuperUserWrapper>
          <NavDropdown title="Spiderman!" id="nav-dropdown-spiderman">
            <LinkContainer to="/login/wszyscy"><NavDropdown.Item>Lista wszystkich operatorów</NavDropdown.Item></LinkContainer>
            <LinkContainer to='/administracja/superuser'><NavDropdown.Item>Stań się kimś innym</NavDropdown.Item></LinkContainer>
            <LinkContainer to='/administracja/zapis'><NavDropdown.Item>Zapisy / lista obecności</NavDropdown.Item></LinkContainer>
            <LinkContainer to='/administracja/xmlfiles'><NavDropdown.Item>Pliki XML</NavDropdown.Item></LinkContainer>
            <LinkContainer to='/administracja/dzWizualizacja'><NavDropdown.Item>Drzwi zewn. wizualizacja</NavDropdown.Item></LinkContainer>
          </NavDropdown>
        </SuperUserWrapper>
      </Nav>
    </div>
    }
  </header >
)

export default Header
